import { type Ref } from 'react';

import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { BUTTON_ICON_SIZE_MEDIUM_MOBILE, ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';
import { ReactComponent as Arrow } from '@pkg/components/Sections/Profile/icons/arrow.svg';

import { ChevronDownIcon } from '@app/pages/Prototype/icons';

export const DropdownWrapper = styled(motion.div)`
    display: flex;
    gap: 20px;
    align-items: center;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        justify-content: space-between;
        width: 100%;
    }
`;

export const DropdownLabel = styled.label`
    position: absolute;
    clip: rect(0, 0, 0, 0);
`;

export const DropdownList = styled(motion.ul)<{ ref: Ref<HTMLUListElement> }>`
    position: relative;
    margin: 0;
    padding: 0;
    list-style-type: none;
    align-items: center;

    li {
        cursor: pointer;
    }
`;

interface DropdownTriggerItemProps {
    $open: boolean;
}

export const DropdownTriggerItem = styled.li<DropdownTriggerItemProps>`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.03em;

    padding: 8px 20px;
    border: 2px solid ${({ theme }) => theme.colors.purple};
    border-radius: 100px;
    min-width: 200px;
    height: 40px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    > span {
        margin-left: 8px;
        width: 9px;
        height: 4px;
    }
`;

export const DropdownIndicator = styled(ChevronDownIcon)`
    fill: none !important;
`;

export const SortButtonsGroup = styled(motion.div)`
    display: flex;
    background: #ffffff1a;
    border-radius: 30px;
`;

interface ArrowProps {
    $pointingUp?: boolean;
}

export const StyledArrow = styled(Arrow)<ArrowProps>`
    ${({ $pointingUp }) =>
        !$pointingUp &&
        css`
            transform: rotate(180deg);
        `}
`;
export const SortIndicator = styled(motion.div)`
    position: absolute;
    width: ${BUTTON_ICON_SIZE_MEDIUM_MOBILE}px;
    height: ${BUTTON_ICON_SIZE_MEDIUM_MOBILE}px;
    background: ${({ theme }) => theme.colors.purple};
    z-index: 0;
    border-radius: 50%;
`;

export const SortButton = styled(ButtonIcon)`
    z-index: 1;
`;

export const DropdownMenu = styled(motion.li)<{ $expanded: boolean }>`
    position: absolute;
    top: 55px;
    left: 0;
    min-width: 245px;
    border-radius: 20px;
    padding: 14px 8px;
    ${({ theme }) => css`
        background: ${theme?.colors.purple};
    `}
    z-index: 50;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    ${({ theme }) => css`
        transition:
            max-height ${theme.transitions.speeds.fast}s ${theme.transitions.easesCss.cubic},
            opacity ${theme.transitions.speeds.fast}s ${theme.transitions.easesCss.cubic};
    `}
    pointer-events: none;

    > ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: grid;
        gap: 6px;
    }

    ${({ $expanded }) =>
        $expanded &&
        css`
            max-height: 100vh;
            overflow: auto;
            opacity: 1;
            pointer-events: initial;
        `};
`;

export const DropdownItem = styled.li<{ $active: boolean }>`
    padding: 8px 12px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${(props) => (props.$active ? '#0907194d' : 'transparent')};
    transition: background-color 0.2s;
    font-size: 14px;
    line-height: 1;
    letter-spacing: -0.03em;
    font-weight: 500;

    &:hover {
        background-color: ${(props) => (props.$active ? '#09071933' : '#ffffff1a')};
    }
`;

export const DropdownItemTitle = styled.span``;
